// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"d0856a97","633":"1fcb0d55","816":"4506ab37"}[chunkId] + ".chunk.js";
};